import React, { Component } from 'react';
import Header from './components/Header/Header';
import PropTypes from 'prop-types';


class Index extends Component {
    render() {
        const { sticky, children, alertOnTop, classes, permissionBarFixed, reportOverlayVisible } = this.props;

        return (
            <Header
                sticky={ sticky }
                alertOnTop={ alertOnTop }
                children={ children }
                classes={ classes }
                permissionBarFixed={ permissionBarFixed }
                reportOverlayVisible={reportOverlayVisible}
            />
        );
    }
}

export default Index;

Index.propTypes = {
    classes: PropTypes.shape({
        header: PropTypes.string,
        headerSticky: PropTypes.string
    })
};
